import {MenuAvatarView} from "./menu-avatar.view";
import React, {useEffect} from "react";
import {ReactKeycloakProvider, useKeycloak} from "@react-keycloak/web";
import Keycloak from "keycloak-js";

import PropTypes, {InferProps} from "prop-types";
import {useApolloClient} from "@apollo/client";
import {KEYCLOAK_CONFIG} from "../config/front-config";
import {Scope} from "@betrue/shared/interfaces";
import {usePrincipal} from "@betrue/front/services";

export const MenuAvatarPropsTypes = {
  loginLabel: PropTypes.string,
  logoutLabel: PropTypes.string,
  profileLabel: PropTypes.string,
  invoicesUrl: PropTypes.string,
  invoicesLabel: PropTypes.string,
  secretsLabel: PropTypes.string,
  crmLabel: PropTypes.string,
  partnerDomain: PropTypes.string,
  customerDomain: PropTypes.string,
}
export type MenuAvatarProps = InferProps<typeof MenuAvatarPropsTypes>

export const MenuAvatar = (props: MenuAvatarProps) => {
  const {keycloak, initialized} = useKeycloak()
  const [principal] = usePrincipal()
  const client = useApolloClient()

  useEffect(() => {

    if (principal && window.PARTNER_DOMAIN && window.CUSTOMER_DOMAIN) {
      if (principal.scope === Scope.CUSTOMER && window.CUSTOMER_DOMAIN !== window.location.hostname) {
        window.location.href = `https://${window.CUSTOMER_DOMAIN}${window.location.pathname}${window.location.search}`
      } else if (principal.scope === Scope.PARTNER && window.PARTNER_DOMAIN !== window.location.hostname) {
        window.location.href = `https://${window.PARTNER_DOMAIN}${window.location.pathname}${window.location.search}`
      }

    }
  }, [principal])

  const handleLogOut = () => {
    localStorage.clear()
    client.clearStore()
    keycloak.logout()
  }

  if (!principal) return (<></>)

  return (
    <MenuAvatarView logoutLabel={props.logoutLabel}
                    person={principal} onLogOut={handleLogOut}/>
  );
}


export const KCMenuAvatar = (props: MenuAvatarProps) => {

  const keycloak = Keycloak(
    {
      url: KEYCLOAK_CONFIG().authServerUrl,
      realm: KEYCLOAK_CONFIG().realm,
      clientId: KEYCLOAK_CONFIG().clientId
    }
  )
  return <ReactKeycloakProvider authClient={keycloak}
                                initOptions={KEYCLOAK_CONFIG().init}>
    <MenuAvatar logoutLabel={props.logoutLabel} loginLabel={props.loginLabel}/>
  </ReactKeycloakProvider>

}
MenuAvatar.propTypes = MenuAvatarPropsTypes
